import Enroll from '../pages/Enroll';
import Welcome from '../pages/Welcome';
import { AuthB2cProvider } from '../context/AuthB2cContext';
import Recap from '../pages/Recap';
import Thanks from '../pages/Thanks';
import Carrier from '../pages/Carrier';
import RequireToken from '../components/RequireToken';
import {
  CARRIER_ROUTE,
  DATA_ENTRY_EIGHTH_STEP_ROUTE,
  DATA_ENTRY_FIFTH_STEP_ROUTE,
  DATA_ENTRY_FIRST_STEP_ROUTE,
  DATA_ENTRY_FOURTH_STEP_ROUTE,
  DATA_ENTRY_SECOND_STEP_ROUTE,
  DATA_ENTRY_SEVENTH_STEP_ROUTE,
  DATA_ENTRY_SIXTH_STEP_ROUTE,
  DATA_ENTRY_THIRD_STEP_ROUTE,
  RECAP_ROUTE,
  THANKS_ROUTE,
  WELCOME_ROUTE,
  SETUP_ROUTE,
} from '../constants/baseRoutePaths';
import Setup from '../pages/Setup.tsx';

export const b2cRoutes = [
  { index: true, element: <Welcome /> },
  {
    path: WELCOME_ROUTE,
    element: (
      <AuthB2cProvider>
        <Welcome />
      </AuthB2cProvider>
    ),
  },
  {
    path: DATA_ENTRY_FIRST_STEP_ROUTE,
    element: (
      <AuthB2cProvider>
        <RequireToken>
          <Enroll step={0} />
        </RequireToken>
      </AuthB2cProvider>
    ),
  },
  {
    path: DATA_ENTRY_SECOND_STEP_ROUTE,
    element: (
      <AuthB2cProvider>
        <RequireToken>
          <Enroll step={1} />
        </RequireToken>
      </AuthB2cProvider>
    ),
  },
  {
    path: DATA_ENTRY_THIRD_STEP_ROUTE,
    element: (
      <AuthB2cProvider>
        <RequireToken>
          <Enroll step={2} />
        </RequireToken>
      </AuthB2cProvider>
    ),
  },
  {
    path: DATA_ENTRY_FOURTH_STEP_ROUTE,
    element: (
      <AuthB2cProvider>
        <RequireToken>
          <Enroll step={3} />
        </RequireToken>
      </AuthB2cProvider>
    ),
  },
  {
    path: DATA_ENTRY_FIFTH_STEP_ROUTE,
    element: (
      <AuthB2cProvider>
        <RequireToken>
          <Enroll step={4} />
        </RequireToken>
      </AuthB2cProvider>
    ),
  },
  {
    path: DATA_ENTRY_SIXTH_STEP_ROUTE,
    element: (
      <AuthB2cProvider>
        <RequireToken>
          <Enroll step={5} />
        </RequireToken>
      </AuthB2cProvider>
    ),
  },
  {
    path: DATA_ENTRY_SEVENTH_STEP_ROUTE,
    element: (
      <AuthB2cProvider>
        <RequireToken>
          <Enroll step={6} />
        </RequireToken>
      </AuthB2cProvider>
    ),
  },
  {
    path: DATA_ENTRY_EIGHTH_STEP_ROUTE,
    element: (
      <AuthB2cProvider>
        <RequireToken>
          <Enroll step={7} />
        </RequireToken>
      </AuthB2cProvider>
    ),
  },
  {
    path: RECAP_ROUTE,
    element: (
      <AuthB2cProvider>
        <RequireToken>
          <Recap />
        </RequireToken>
      </AuthB2cProvider>
    ),
  },
  {
    path: CARRIER_ROUTE,
    element: (
      <AuthB2cProvider>
        <RequireToken>
          <Carrier />
        </RequireToken>
      </AuthB2cProvider>
    ),
  },
  {
    path: THANKS_ROUTE,
    element: (
      <AuthB2cProvider>
        <Thanks />
      </AuthB2cProvider>
    ),
  },
  {
    path: SETUP_ROUTE,
    element: <Setup />,
  },
];
